// extracted by mini-css-extract-plugin
export default {"hidden":"axkHh2"};